// CourseCard.js
import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

import "./careers.css";

const CourseCard = ({ course }) => {
  console.log("course: ", course)
  if (!course) {
    return <p>No data available</p>; // Fallback if data is undefined or empty
  }
  return (
    <div className="side-content col-md-4 mb-3 courses_sectionn career_card">
      <Fade direction="up">
        <div className="card courses_section_card">
          <div className="coursesCard -type-1">
            <div className="relative">
              <div className="coursesCard__image overflow-hidden rounded-8 position-relative">
                <img
                  src={course.imageUrl}
                  alt="card-image"
                  className="w-1\/1 zoom-image"
                />
                <div className="coursesCard__image_overlay rounded-8"></div>
              </div>
              <div className="d-flex justify-between py-10 px-10 absolute-full-center z-3"></div>
            </div>

            <div className="h-100 pt-15">

              <div className="d-flex flex-column text-dark career_card">
                <div className="mt-2"><b>Role: </b> <cite>{course.title}</cite></div>
                <div className="mt-2"><b>Work Experience:</b> <cite>{course.workExperience}</cite></div>
                <div className="mt-2"><b>Job Location:</b> <cite>India/Singapore</cite></div>
                <div className="mt-2"><b>Job Description:</b> <cite>{course.description}</cite></div>
                <div className="mt-2"><b>Technical Skills:</b>
                  <ul>
                    {course.technicalSkills.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="mt-2"><b>Responsibilities:</b>
                  <ul>
                    {course.responsibilities.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </div>


                <a href="https://docs.google.com/forms/d/1KWrskFc61WYTR-LLDpZcKORZcUjYjqgtBEkfJvsqTJk/viewform?edit_requested=true" target="_blank">
                  <button
                    className="course_cart_btn"
                  >
                    Apply Now
                  </button></a>
              </div>

            </div>

          </div>
        </div>
      </Fade>

      {/* <div className="side-content__item">
          <div className="px-30 pt-20 pb-30 bg-white rounded-8 border-light shadow-2">
            <div className="text-18 lh-16 text-dark-1 course_title"><b>Role: {course.title}</b></div>

            
            <div className="d-flex flex-column text-dark">
                    <div className="mt-2"><b>Work Experience:</b> <cite>{course.workExperience}</cite></div>
                    <div className="mt-2"><b>Job Location:</b> <cite>India/Singapore</cite></div>
                    <div className="mt-2"><b>Job Description:</b> <cite>{course.description}</cite></div>
                    <div className="mt-2"><b>Technical Skills:</b> 
                        <ul>
                            {course.technicalSkills.map((item) => (
                                <li>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="mt-2"><b>Responsibilities:</b> 
                        <ul>
                            {course.responsibilities.map((item) => (
                                <li>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <button
                  className="course_cart_btn"
                >
                  Apply Now
                </button>
                </div>
          
          </div>
        </div> */}

    </div>
  );
};

export default CourseCard;
